import axios from "axios";

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
export const API = `${BACKEND_URL}/api`;
export { BACKEND_URL };

const ACCESS_KEY = "postelier_access";
const REFRESH_KEY = "postelier_refresh";
const MEDIA_KEY = "eyt_media";

export function setTokens(access, refresh) {
  if (access) localStorage.setItem(ACCESS_KEY, access);
  if (refresh) localStorage.setItem(REFRESH_KEY, refresh);
}
export function clearTokens() {
  localStorage.removeItem(ACCESS_KEY);
  localStorage.removeItem(REFRESH_KEY);
  localStorage.removeItem(MEDIA_KEY);
}
export function getAccessToken() {
  return localStorage.getItem(ACCESS_KEY);
}
export function setMediaToken(t) {
  if (t) localStorage.setItem(MEDIA_KEY, t);
}
export function getMediaToken() {
  return localStorage.getItem(MEDIA_KEY);
}

// Resolve an image URL for <img src>. AI visuals are served by our backend
// (/api/media/...) and need a READ-ONLY media token appended (img tags can't
// send headers). This token only grants media reads, never full API access.
export function imgSrc(url) {
  if (!url) return url;
  let full = url;
  if (url.startsWith("/api/")) full = BACKEND_URL + url;
  if (full.includes("/api/media/")) {
    const t = getMediaToken() || getAccessToken();
    return full + (full.includes("?") ? "&" : "?") + "auth=" + encodeURIComponent(t || "");
  }
  return full;
}

export const api = axios.create({
  baseURL: API,
  withCredentials: true,
});

// Attach bearer token (works even when 3rd-party cookies are blocked in the iframe)
api.interceptors.request.use((cfg) => {
  const t = localStorage.getItem(ACCESS_KEY);
  if (t) cfg.headers.Authorization = `Bearer ${t}`;
  return cfg;
});

// On 401, try to refresh the access token once, then retry the original request.
let refreshPromise = null;
api.interceptors.response.use(
  (res) => res,
  async (error) => {
    const original = error.config;
    const url = original?.url || "";
    const isAuthCall = url.includes("/auth/login") || url.includes("/auth/refresh");
    if (error.response?.status === 401 && original && !original._retry && !isAuthCall) {
      original._retry = true;
      const rt = localStorage.getItem(REFRESH_KEY);
      if (!rt) {
        clearTokens();
        if (typeof window !== "undefined" && window.location.pathname !== "/login") {
          window.location.href = "/login";
        }
        return Promise.reject(error);
      }
      try {
        refreshPromise =
          refreshPromise ||
          api.post("/auth/refresh", { refresh_token: rt });
        const { data } = await refreshPromise;
        refreshPromise = null;
        if (data?.access_token) setTokens(data.access_token);
        original.headers = original.headers || {};
        if (data?.access_token) original.headers.Authorization = `Bearer ${data.access_token}`;
        return api(original);
      } catch (e) {
        refreshPromise = null;
        clearTokens();
        if (typeof window !== "undefined" && window.location.pathname !== "/login") {
          window.location.href = "/login";
        }
        return Promise.reject(error);
      }
    }
    return Promise.reject(error);
  }
);

export function formatApiErrorDetail(detail) {
  if (detail == null) return "Une erreur est survenue. Réessaie.";
  if (typeof detail === "string") return detail;
  if (Array.isArray(detail))
    return detail
      .map((e) => (e && typeof e.msg === "string" ? e.msg : JSON.stringify(e)))
      .filter(Boolean)
      .join(" ");
  if (detail && typeof detail.msg === "string") return detail.msg;
  return String(detail);
}
